<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-tabs [(ttSelectedId)]="selectedBgPriceType">
                <tt-tab ttId="PRICELIST" ttLabel="productprices_pricelists"></tt-tab>
                <tt-tab ttId="PURCHPRICE" ttLabel="productprices_purchprice"></tt-tab>
            </tt-tabs>

            <tt-select *ngIf="setting.show_prodsize_keyno === '1'" ttLabel="prodsize_keyno" [(ttModel)]="setting.prodsize_keyno" (ttModelChange)="onChanged($event, 'prodsize_keyno')" [ttData]="selectListProductSizes" ttDataId="item_id" ttDataName="item_name"></tt-select>
            <tt-select [hidden]="selectedBgPriceType !== 'PRICELIST'" *ngIf="setting.show_pricegrp_keyno === '1'" ttLabel="pricegrp" [(ttModel)]="setting.pricegrp_keyno" (ttModelChange)="onChanged($event, 'pricegrp_keyno')" [ttData]="selectListPriceGroups" ttDataId="pricegrp_keyno" ttDataName="pricegrp_name" [ttButtons]="priceGroupButtons"></tt-select>
        </tt-card>

        <tt-list-legacy [hidden]="selectedBgPriceType !== 'PRICELIST'" [listItems]="itemsListRelatedToPriceGroups" ltype="multi" [designVar]="'s12t0'" typevar="g"></tt-list-legacy>
        <tt-list-legacy [hidden]="selectedBgPriceType !== 'PURCHPRICE'" [listItems]="itemsListRelatedToProductSizes" ltype="multi" [designVar]="'s12t0'" typevar="g"></tt-list-legacy>

        <tt-card>
            <div [hidden]="selectedBgPriceType !== 'PRICELIST'">
                <ng-container *ngTemplateOutlet="directionAndUpdateButtons"></ng-container>
            </div>

            <tt-button-goto [hidden]="selectedBgPriceType !== 'PURCHPRICE'" ttText="productprices_new_purchprice" ttGoto="purchprice" [ttGotoParms]="{ prodsize_keyno: setting.prodsize_keyno, purchprice_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
        </tt-card>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="productprices_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="50">
                    <tt-card ttHeading="productprices_pricelists" ttTranslate>
                        <tt-select *ngIf="setting.show_prodsize_keyno === '1'" ttLabel="prodsize_keyno" [(ttModel)]="setting.prodsize_keyno" (ttModelChange)="onChanged($event, 'prodsize_keyno')" [ttData]="selectListProductSizes" ttDataId="item_id" ttDataName="item_name"></tt-select>
                        <tt-select *ngIf="setting.show_pricegrp_keyno === '1'" ttLabel="pricegrp" [(ttModel)]="setting.pricegrp_keyno" (ttModelChange)="onChanged($event, 'pricegrp_keyno')" [ttData]="selectListPriceGroups" ttDataId="pricegrp_keyno" ttDataName="pricegrp_name" [ttButtons]="priceGroupButtons"></tt-select>
                    </tt-card>

                    <tt-list-legacy [listItems]="itemsListRelatedToPriceGroups" ltype="multi" [designVar]="'s12t0'" typevar="g"></tt-list-legacy>

                    <tt-card>
                        <ng-container *ngTemplateOutlet="directionAndUpdateButtons"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="50">
                    <tt-card ttHeading="productprices_purchprice" ttTranslate></tt-card>
                    <tt-list-legacy [listItems]="itemsListRelatedToProductSizes" ltype="multi" [designVar]="'s12t0'" typevar="g"></tt-list-legacy>

                    <tt-card>
                        <tt-button-goto ttText="productprices_new_purchprice" ttGoto="purchprice" [ttGotoParms]="{ prodsize_keyno: setting.prodsize_keyno, purchprice_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
                    </tt-card>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #directionAndUpdateButtons>
    <ng-container *ngIf="!!setting">
        <tt-button-goto ttText="create_new_price" ttGoto="price" [ttGotoParms]="{ pricegrp_keyno: setting.pricegrp_keyno, price_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>

        <div *ngIf="setting.show_approve_prices === '1'">
            <tt-button ttText="productprices_approve_pricenext" (ttClick)="approveChanges()" [ttSpin]="approving" ttIcon="fas fa-sync"></tt-button>
            <tt-button ttText="productprices_rollback_pricenow" (ttClick)="rollbackChanges()" [ttSpin]="rollbacking" ttIcon="fas fa-sync"></tt-button>
        </div>

        <tt-button ttText="productprices_refresh_pricegrps" (ttClick)="refreshPriceGroupsChanges()" [ttSpin]="refreshingPriceGroups" ttIcon="fas fa-sync"></tt-button>
        <tt-button-settings *ngIf="setting.show_setting === '1'"></tt-button-settings>
    </ng-container>
</ng-template>
